module.exports = __webpack_public_path__ + "ccf72e529e427be4b25e8bbaef17ca5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/legacy/kennung.png
// module id = 1502
// module chunks = 0